import Component from './Component';
import React from 'react';

class Toolbar extends Component {

	static defaultProps = {
		visible:true
	};

	render() {
		if (!this.props.visible) {
			return false;
		}
		return <div className="formtoolbar hidden-xs">
				<h3>{this.props.title.title ? this.props.title.title : this.props.title}</h3>
					{this.props.buttons || this.props.children}
					{this.props.title.subtitle && <div>{this.props.title.subtitle}</div>}
					<hr />
				</div>
	}

}

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/Toolbar.js